import reducer from './reducers';
import * as wsOperations from './operations';

export { default as wsTypes } from './types';
export { default as wsActions } from './actions';

export {
  wsOperations,
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/websockets/index.js